import { render, staticRenderFns } from "./SearchResult.vue?vue&type=template&id=de87aa5a"
import script from "./SearchResult.vue?vue&type=script&lang=js"
export * from "./SearchResult.vue?vue&type=script&lang=js"
import style0 from "./SearchResult.vue?vue&type=style&index=0&id=de87aa5a&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports